import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { ITvodOtpGenerateRequest, ITvodOtpVerifyRequest } from '../../../entity/interface/iEntitlements';
export interface ITvodOtpVerifyUseCase {
    execute(payload: ITvodOtpVerifyRequest, username: string, token: string, identityToken: string): Promise<any>;
}

export class TvodOtpVerifyUseCase implements ITvodOtpVerifyUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get tvodOtpVerifyRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: ITvodOtpVerifyRequest,
        username: string,
        token: string,
        identityToken: string
    ): Promise<any> {
        return this.tvodOtpVerifyRepository.tvodOtpVerify(payload, username, token, identityToken);
    }
}
